export const impersonationConstant = {
    IMPERSONATION_START: 'app/impersonation/IMPERSONATION_START',
    IMPERSONATION_END: 'app/impersonation/IMPERSONATION_END',
    IMPERSONATION_HYDRATE: 'app/impersonation/IMPERSONATION_HYDRATE',
};
